// extracted by mini-css-extract-plugin
export default {"tickGradientBorder":"Slider_tickGradientBorder__V5xnr","handleGradientBorder":"Slider_handleGradientBorder__QFWz8"};